var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "rating-container" }, [
    _c("div", { staticClass: "h2 heading" }, [
      _vm._v("Wie gut hat Dir dieser Artikel gefallen?")
    ]),
    _vm._v(" "),
    _c(
      "ul",
      { staticClass: "rating-listing" },
      _vm._l(5, function(rating) {
        return _c("li", {
          staticClass: "rating-label",
          class: {
            active: rating <= _vm.ratingParam,
            disabled: _vm.ratingParam > 0,
            "rating-listing-cookies-not-accepted disabled": !_vm.cookiesAccepted
          },
          on: {
            click: function($event) {
              return _vm.setRating(rating)
            }
          }
        })
      }),
      0
    ),
    _vm._v(" "),
    _c("p", {
      staticClass: "rating-message",
      class: [_vm.ratingMessage == null ? "invisible" : ""],
      domProps: { textContent: _vm._s(_vm.ratingMessage) }
    }),
    _vm._v(" "),
    !_vm.cookiesAccepted
      ? _c(
          "div",
          {
            staticClass: "cookie-consent-overlay",
            on: {
              click: function($event) {
                $event.preventDefault()
                return _vm.openCookieSettings.apply(null, arguments)
              }
            }
          },
          [
            _vm._v(
              "\n        Bitte akzeptiere hier die funktionellen Cookies, um diesen Artikel zu bewerten:\n      "
            ),
            _c(
              "a",
              {
                attrs: { href: "#" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.openCookieSettings.apply(null, arguments)
                  }
                }
              },
              [_vm._v("Cookie-Einstellungen verwalten.")]
            )
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-343e5058", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-343e5058","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./public/js/components/Rating.vue
// module id = 592
// module chunks = 0